<template lang="pug">
  div
    h2(class="title-32px fw-700 mb-2") {{ $t('Signer in document name') }}
    div(class="text-14px fw-300") {{ $t('After the counterparty signs the document, their surname, first name and patronymic are automatically added to the file name') }}
    v-switch(
      v-model="addFullName"
      hide-details
      :label="$t('Add full name to document name')"
      class="py-8 mt-0"
    )
    div(
      v-if="addFullName"
      class="highlighted-block"
    )
      div
        e-svg-icon info-circle-primary
      div(class="text-12px fw-300 color-primary") {{ $t('The full name is taken from the counterparty`s signature. If the document is signed by several persons, the full name of the first signatory is added') }}
    div(class="two-buttons-wrapper pt-8")
      v-btn(
        height="48"
        @click="closeModal(false)"
      ) {{ $t('Come back') }}
      v-btn(
        class="main-button"
        :loading="loading"
        @click="submit"
      ) {{ $t('Save changes') }}
</template>

<script>
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'

export default {
  name: 'FormTemplateSignerName',
  mixins: [informationSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    template: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      addFullName: false,
      loading: false
    }
  },
  created() {
    this.addFullName = this._.get(this.template, 'dynamicDocumentName', false)
  },
  methods: {
    async submit() {
      if (this.addFullName === this._.get(this.template, 'dynamicDocumentName')) {
        this.closeModal(true)
        return
      }
      try {
        this.loading = true
        await this.$store.dispatch('templates/update', {
          id: this.$route.params.id,
          payload: {
            dynamicDocumentName: this.addFullName
          }
        })
        this.closeModal(true)
        await this.informationSnackbar.open({
          icon: 'check-circle-white-filled',
          text: this.$t('Full name added to document name')
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.highlighted-block {
  display: flex;
  gap: 12px;

  border-radius: 12px;
  padding: 12px 16px;
  background: $primary-light;
}
</style>
